import withIconProps from './withIconProps';
import RakutenAiIconGraySVG from './icon_r_ai_symbol_gray.svg';

export default withIconProps(RakutenAiIconGraySVG);
